import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, ArrowRight, Heart } from 'lucide-react';
import { useSavedListings } from '@/hooks/useSavedListings';
import JobCard from '@/components/card/JobCard';
import { Spinner, Pagination } from '@/components/common';

export default function SavedJobsPage() {
  const [filters, setFilters] = useState({
    entityType: 'JobOffer',
    page: 1,
    limit: 10,
    orderBy: 'createdAt',
    orderDirection: 'DESC'
  });

  const { data: listingsData, isLoading } = useSavedListings(filters);
  const jobs = listingsData?.data?.filter((l) => l.entityType === 'JobOffer' && l.jobOffer).map((l) => l.jobOffer!) ?? [];

  const total = listingsData?.total ?? 0;
  const totalPages = Math.ceil(total / filters.limit);

  return (
    <div className="max-w-6xl mx-auto pb-12">
      {/* Header */}
      <div className="mb-6">
        <div className="section-label">Việc làm</div>
        <div className="flex items-end justify-between flex-wrap gap-2">
          <div>
            <h1 className="section-title mb-1">Tin đã lưu</h1>
            <p className="text-sm" style={{ color: 'var(--text-3)' }}>
              Danh sách các việc làm bạn đã lưu lại
            </p>
          </div>
          <Link
            to="/viec-lam"
            className="flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-xl border hover:border-orange-400 hover:text-orange-500 transition-colors"
            style={{ borderColor: 'var(--border-c)', color: 'var(--text-2)' }}
          >
            <Briefcase size={14} /> Tìm thêm việc làm
          </Link>
        </div>
      </div>

      {/* List */}
      {isLoading ? (
        <Spinner />
      ) : jobs.length === 0 ? (
        <div className="text-center py-24 rounded-2xl border" style={{ borderColor: 'var(--border-c)', background: 'var(--surface-0)' }}>
          <p className="text-5xl mb-4 text-orange-400 flex justify-center"><Heart size={48} /></p>
          <p className="font-bold text-lg mb-2" style={{ color: 'var(--text-1)' }}>
            Bạn chưa lưu việc làm nào
          </p>
          <p className="text-sm mb-6" style={{ color: 'var(--text-3)' }}>
            Lưu lại các việc làm hấp dẫn để xem lại sau
          </p>
          <Link to="/viec-lam" className="btn-brand inline-flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold">
            Khám phá việc làm <ArrowRight size={15} />
          </Link>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {jobs.map((job, i) => (
              <div key={job.id} className="animate-fade-up h-full" style={{ animationDelay: `${i * 50}ms` }}>
                <JobCard job={job} />
              </div>
            ))}
          </div>
          {totalPages > 1 && (
            <Pagination
              page={filters.page}
              totalPages={totalPages}
              onChange={(p) => setFilters((f) => ({ ...f, page: p }))}
            />
          )}
        </>
      )}
    </div>
  );
}
